import { cn } from '@nextui-org/react'
import { MessageSquareText } from 'lucide-react'
import { type ReactNode } from 'react'
import DocMarkdown from '~/components/documents/DocMarkdown'
import { preprocessContent } from '~/components/task/DocsPanel'
import {
  RIGHT_PANEL_MARKDOWN_CLASS,
  RightPanelHorizontalScrollStyles
} from '~/components/task/RightPanelHorizontalScroll'

interface ReviewBriefProps {
  summary?: string
  action?: ReactNode
  className?: string
  contentBounded?: boolean
  contentClassName?: string
  sticky?: boolean
  testId?: string
}

export default function ReviewBrief({
  summary,
  action,
  className,
  contentBounded = true,
  contentClassName,
  sticky = true,
  testId = 'review-brief'
}: ReviewBriefProps) {
  const normalizedSummary = summary?.trim()
  if (!normalizedSummary) return null

  return (
    <section
      data-testid={testId}
      className={cn(
        sticky && 'sticky top-0 z-20',
        'shrink-0 rounded-2xl border border-tokens-neutral-border-2 bg-tokens-neutral-bg-white p-3 shadow-segment',
        className
      )}
    >
      <div className='flex items-center justify-between gap-3'>
        <div className='flex min-w-0 items-center gap-2 text-xs font-semibold uppercase text-tokens-neutral-text-secondary'>
          <MessageSquareText className='h-4 w-4 shrink-0 text-tokens-neutral-icon-default' />
          <span className='truncate'>Review brief</span>
        </div>
        {action ? <div className='shrink-0'>{action}</div> : null}
      </div>
      <div
        className={cn(
          'mt-2 min-w-0 text-sm text-tokens-neutral-text-primary',
          contentBounded ? 'max-h-32 overflow-auto' : 'overflow-visible',
          contentClassName
        )}
      >
        <RightPanelHorizontalScrollStyles />
        <DocMarkdown
          text={preprocessContent(normalizedSummary)}
          className={RIGHT_PANEL_MARKDOWN_CLASS}
        />
      </div>
    </section>
  )
}
